// extracted by mini-css-extract-plugin
export default {"kenoRiskAutoWrap":"styles_kenoRiskAutoWrap__V6p-F","kenoRiskDropWrap":"styles_kenoRiskDropWrap__WIxkN"};